import productDetailtheme from '../../pages/productDetail'

export default {
    baseStyle: {
        productViewHeaderContainer: {
            mr: 4,
            spacing: 2,
            align: 'flex-start'
        },
        productViewHeaderTitle: {
            fontSize: '3xl',
            textTransform: 'uppercase',
            marginBottom: '10px'
        },
        productViewPageButtonAddToCart: {
            width: ['full', null, null, 'auto']
        },
        productViewLayout: {
            mt: [0, null, null, 32],
            gap: [16, null, null, 0]
        },
        productImages: {
            flex: [1, null, null, '1 0 50%'],
            pr: [0, null, null, 12],
            spacing: 16
        },
        productDescription: {
            flex: [1, null, null, '1 0 50%']
        },
        productAttributes: {
            align: 'stretch',
            gap: [0, null, null, 32],
            flex: 1,
            pl: [0, null, null, 12]
        },
        productBrandHeader: productDetailtheme.productBrandHeader,
        addToWishListInTitle: {
            display: 'none'
        },
        colorSwatches: {
            height: '100%',
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            border: '1px solid',
            borderColor: 'fullBlack'
        },
        productDetailsDescriptionDesktop: productDetailtheme.productDetailsDescriptionDesktop,
        productViewPageSeoLinksTitle: productDetailtheme.productViewPageSeoLinksTitle,
        productViewPageSeoLinks: productDetailtheme.productViewPageSeoLinks,
        productViewPageSeoLinksLists: productDetailtheme.productViewPageSeoLinksLists
    }
}
